// Authentication states
export const AUTH_STATES = {
  LOGIN: "login",
  OTP: "otp",
  DASHBOARD: "dashboard",
} as const;

// User roles
export const USER_ROLES = {
  ADMIN: "admin",
  MEMBER: "member",
} as const;

// Session timeout
export const SESSION_TIMEOUT = 5 * 60 * 1000; // 5 minutes

// Cookie settings
export const COOKIE_SETTINGS = {
  HTTP_ONLY: true,
  SECURE: process.env.NODE_ENV === "production",
  SAME_SITE: "strict" as const,
} as const;

// Database encryption
export const ENCRYPTION_ALGORITHM = "aes-256-cbc";
export const ENCRYPTION_KEY_LENGTH = 32;

// External URLs
export const EXTERNAL_URLS = {
  POLIMI_LOGIN: "https://aunicalogin.polimi.it/aunicalogin/getservizio.xml?id_servizio=376",
  POLIMI_AUTH:
    "https://aunicalogin.polimi.it/aunicalogin/aunicalogin/controller/IdentificazioneUnica.do?&jaf_currentWFID=main&polij_step=0&__pj0=0&__pj1=5205b0f9cce40e62ec62e9e3b873dde6",
  POLIMI_OTP:
    "https://aunicalogin.polimi.it/aunicalogin/aunicalogin/controller/passi/IdentificazioneDFA.do?jaf_currentWFID=main&polij_step=0&__pj0=0&__pj1=c007151d47d7b9effe7b159b288a843f",
  POLIMI_WELFARE_STEP1:
    "https://aunicalogin.polimi.it/aunicalogin/aunicalogin.jsp?lang=IT&id_servizio=3137&id_servizio_idp=828&__pj0=0",
  POLIMI_WELFARE_STEP2:
    "https://aunicalogin.polimi.it/aunicalogin/aunicalogin/controller/AunicaLogin.do?evn_checkCookieSSO=evento&COOKIES_VALUES_SSO_LOGOUT=S3137_-S828_-&lang=IT&id_servizio=3137&id_servizio_idp=828&scope=openid&redirect_uri=https%3A%2F%2Flogin.360welfare.it%2Fpolitecnico_return_uri.php&state=prova&client_id=3137-welfare.dsu&__pj0=0",
  WELFARE_LOGIN: "https://login.360welfare.it/politecnico_auth.php",
  WELFARE_DASHBOARD: "https://login.360welfare.it/titolare3/index.php",
  WELFARE_TOKEN: "https://login.360welfare.it/titolare3/titolare_exe.php?azione=GENERA_TOKEN",
  WELFARE_MOVIMENTI: "https://login.360welfare.it/titolare3/mw_movimenti_BPE.php",
} as const;

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/api/auth/login",
    OTP: "/api/auth/2fa",
    ME: "/api/auth/me",
    LOGOUT: "/api/auth/logout",
  },
  GROUPS: {
    LIST: "/api/user/groups",
    CREATE: "/api/groups",
    DETAILS: "/api/groups/:id",
    JOIN: "/api/groups/join",
    LEAVE: "/api/groups/:id/leave",
    INVITES: {
      CREATE: "/api/groups/:id/invites",
      LIST: "/api/groups/:id/invites",
      REVOKE: "/api/groups/:id/invites/:code",
    },
  },
  TOKENS: {
    GENERATE: "/api/tokens/generate",
  },
} as const;

// Form validation
export const VALIDATION = {
  CODICE_PERSONA_MIN_LENGTH: 6,
  PASSWORD_MIN_LENGTH: 8,
  GROUP_NAME_MIN_LENGTH: 3,
  GROUP_NAME_MAX_LENGTH: 50,
  INVITE_CODE_LENGTH: 6,
} as const;
